// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import Vue2Filters from 'vue2-filters';
import BootstrapVue from 'bootstrap-vue';
import PrismicVue from 'prismic-vue';
import VueGoogleCharts from 'vue-google-charts';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee, faUser, faUsers, faClock, faCheck, faTimes, faInfoCircle, faArrowAltCircleUp, faArrowDown, faArrowRight, faEye, faChessBoard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App';
import router from './router';
import iam from './iam';
import linkResolver from './prismic-link-resolver';

iam.init();
library.add(
  faCoffee,
  faUser,
  faUsers,
  faClock,
  faCheck,
  faEye,
  faChessBoard,
  faTimes,
  faInfoCircle,
  faArrowAltCircleUp,
  faArrowDown,
  faArrowRight);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(Vue2Filters);
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
});
Vue.use(VueGoogleCharts);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});




// WEBPACK FOOTER //
// ./src/main.js